const AgentsConstants = {
  SET_VISIBLE_RANGE: 'AGENTS_SET_VISIBLE_RANGE',
  REFRESH: 'AGENTS_REFRESH',
  GET: 'AGENTS_GET',
  GET_SUCCESS: 'AGENTS_GET_SUCCESS',
  GET_FAIL: 'AGENTS_GET_FAIL',
  RELOAD: 'AGENTS_RELOAD',
  SET_FILTER: 'AGENTS_SET_FILTER',
  ACTIVATE_FILTER: 'AGENTS_ACTIVATE_FILTER',
  SET_ADVANCED_FILTER: 'AGENTS_SET_ADVANCED_FILTER',
  SET_SORTORDER: 'AGENTS_SET_SORTORDER',
  MODIFY_SELECTION: 'AGENTS_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'AGENTS_ALLOW_MULTI_SELECT',
  REMOVE: 'AGENTS_REMOVE',
  REMOVE_SUCCESS: 'AGENTS_REMOVE_SUCCESS',
  REMOVE_FAIL: 'AGENTS_REMOVE_FAIL',
  SAVE_SUCCESS: 'AGENTS_SAVE_SUCCESS',
  ENSURE_SELECTION_IS_VISIBLE: 'AGENTS_ENSURE_SELECTION_IS_VISIBLE',
  CLEAR: 'AGENTS_CLEAR',
  UPDATE: 'AGENTS_UPDATE',
  SET_SELECTION: 'AGENTS_SET_SELECTION',
  OPEN: 'AGENTS_OPEN',
  GET_FOR_OPEN_SUCCESS: 'AGENTS_GET_FOR_OPEN_SUCCESS',
  GET_BY_ID_SUCCESS: 'AGENTS_GET_BY_ID_SUCCESS',
  FIND_SUCCESS: 'AGENTS_FIND_SUCCESS',
};

export default AgentsConstants;